import AxiosInstance from 'config/apiServiceApiGateway'

import {
  ApprovalStatsResponseInterface,
  ApprovalListParamsInterface,
  ApprovalListResponseInterface,
  ApprovalSubmissionResponseInterface,
  ApprovalSubmissionParamsInterface,
  ApprovalLogInterface,
  ApprovalLogParamsInterface,
  ApprovalWorkflowsInterface,
  ApprovalWorkflowComponentsResponseInterface,
  ApprovalWorkflowListResponseInterface,
} from 'features/ApprovalEngine/@types/ApprovalListTypes'

export const getApprovalEngineStatsAPI = () =>
  AxiosInstance.Get<ApprovalStatsResponseInterface, true>({
    url: '/workflow/internal/v1/approvals/stats',
  })

export const getApprovalWorkflowComponentsAPI = () =>
  AxiosInstance.Get<ApprovalWorkflowComponentsResponseInterface, true>({
    url: '/workflow/internal/v1/workflows/components',
  })

export const getApprovalWorkflowListAPI = () =>
  AxiosInstance.Get<ApprovalWorkflowListResponseInterface, true>({
    url: '/workflow/internal/v1/workflows',
  })

export const getApprovalEngineListAPI = (params: ApprovalListParamsInterface) =>
  AxiosInstance.Get<ApprovalListResponseInterface, true>({
    url: '/workflow/internal/v1/approvals',
    params,
  })

export const putApprovalEngineSubmitAPI = (params: ApprovalSubmissionParamsInterface) =>
  AxiosInstance.Put<ApprovalSubmissionResponseInterface, true>({
    url: '/workflow/internal/v1/approvals',
    data: params,
  })

export const getApprovalEngineLogAPI = (params: ApprovalLogParamsInterface) =>
  AxiosInstance.Get<ApprovalLogInterface, true>({
    url: '/workflow/internal/v1/approval-logs',
    params,
  })

export const getWorkflowsApprovalAPI = (id: string | number) =>
  AxiosInstance.Get<ApprovalWorkflowsInterface, true>({
    url: `/workflow/internal/v1/workflows/${id}`,
  })
